/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import api from ".";

const debugAuth = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.info(...args);
  }
};

export const loginUser = async (username, password) => {
  const response = await api.post("/v1/admin/auth/sign_in", {
    admin: {
      username,
      password,
    }
  });
  
  if (response?.status === 200 && (response?.data?.mfa_required || response?.data?.enrollment_required)) {
    return response?.data;
  }
  
  if (response?.status === 200 && response?.data?.admin) {
    const passwordChanged = response?.data?.admin?.password_changed ?? response?.data?.password_changed;
    
    return { 
      authenticated: true,
      admin: response?.data?.admin,
      token: response?.data?.token,
      password_changed: passwordChanged,
      password_reset_required: response?.data?.password_reset_required,
      message: response?.data?.message
    };
  }
  
  return response?.data;
};

export const logoutUser = async () => {
  try {
    await api.delete("/v1/admin/auth/sign_out");
    debugAuth('AuthManager: logoutUser - sign_out succeeded');
  } catch (error) {
    if (error.response?.status === 401) {
      return;
    }
    console.error('Logout API failed:', error);
  }
};

export const refreshSession = async () => {
  try {
    debugAuth('AuthManager: refreshSession - calling refresh');
    const response = await api.post("/v1/admin/auth/refresh");
    if (response?.status === 200) {
      return true;
    }
  } catch (error) {
    if (error.response?.status === 401) {
      return false;
    }
    throw error;
  }
  return false;
};

export const checkCurrentUser = async () => {
  const response = await api.get("/v1/admin/me");
  debugAuth('AuthManager: checkCurrentUser - response: ', { status: response?.status });
  if (response?.status === 200 && response?.data) {
    return response.data;
  }
  return null;
};
